export default __webpack_public_path__ + "static/media/cTrader-dark.6e9cbce1.png";